<template>
    <div class="modal fade " tabindex="-1" role="dialog" id="modalNewOrder">
        <div class="modal-dialog">
            <div class="modal-content" v-if="newOrder">

                <div class="overlay ModalOverlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>

                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">×</span></button>
                    <h4 class="modal-title"> Ajouter un récapitulatif</h4>
                </div>

                <div class="modal-body">

                    <div class="form-group">
                        <label for="statut">Statut actuel</label>
                        <select id="statut" class="form-control" name="order[statut]"
                                v-model="newOrder.statut.id">
                            <option
                                    v-for="statut in getStatusOrder"
                                    :value="statut.id"
                            > {{statut.type}}
                            </option>
                        </select>
                        <!--<span class="help-block">Help block with error</span>-->
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('order[date]') }">
                        <label>Date d'entrée du récapitulatif</label>
                        <div class="input-group date">
                            <div class="input-group-addon">
                                <i class="fa fa-calendar"></i>
                            </div>
                            <masked-input type="text"
                                          disabled
                                          v-model="newOrder.date"
                                          v-validate="'required|date_format:DD/MM/YYYY'"
                                          :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                          :guide="true"
                                          :keepCharPositions="true"
                                          :showMask="true"
                                          name="order[date]"
                                          class="form-control pull-right datepicker"
                                          id="datepicker2">
                            </masked-input>
                        </div>
                        <span v-show="errors.has('order[date]')"
                              class="help-block">Date incorrecte</span>
                    </div>

                    <list-select-club
                            :clubsLicenciesUniquement="true"
                            title="Club"
                            :clubPreSelected="null"
                            @clubSelected="updateClubSelected"
                    ></list-select-club>

                    <div class="form-group"
                         :class="{'has-error': errors.has('order[comment]') }">
                        <label for="nom">Commentaire</label>
                        <textarea type="text" class="form-control" id="nom" name="order[comment]"
                                  v-validate="'max:255'"
                                  placeholder=""
                                  v-model="newOrder.comment">{{newOrder.comment}}</textarea>
                        <span v-show="errors.has('order[comment]')" class="help-block">Le commentaire doit comporter moins de 255 caractères</span>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-default pull-left" data-dismiss="modal">
                        Fermer
                    </button>
                    <button type="button"
                            class="btn btn-primary"
                            :disabled="errors.count()!=0 || this.newOrder.id_club==0 || this.disabledBtn || this.loadingInputs.length>0"
                            @click="addOrder()"
                    >
                        Ajouter un récapitulatif
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import ListSelectClub from '../../Communs/listeSelectClub'

    var $ = require('jquery');
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                loadingInputs: [],
                disabledBtn: false,
                newOrder: null,
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getStatusOrder: 'getStatusOrder',
                getTextesOrder: 'getTextesOrder',
                getOrder: 'getOrder'
            }),
        },
        mounted: function () {
            var these = this
            this.newForm()
        },
        beforeRouteEnter(to, from, next) {
            next()
        },
        watch: {},
        components: {
            ListSelectClub,
        },
        methods: {
            ...mapActions({}),
            newForm() {
                this.newOrder = {
                    statut: {id: 6},
                    date: moment().format('DD/MM/YYYY'),
                    id_club: 0,
                    comment: ""
                }
            },
            addOrder: function () {
                this.disabledBtn = true;
                let self = this;
                this.$http.post(this.getRoute('Secretariat.orderitulatif.store'), this.constructForm()).then(function (response) {
                    self.$noty.success("Le récapitulatif a bien été créé")
                    self.disabledBtn = false
                    self.$router.push({name: 'Order', params: {order_id: response.body.id}})
                    $('#modalNewOrder').modal('hide')
                }, (response) => {
                    self.$noty.error("Erreur dans la création du nouveau récapitulatif")
                    self.disabledBtn = false
                    $('#modalNewOrder').modal('hide')
                });
            },
            updateClubSelected: function (value) {
                this.newOrder.id_club = value.id
            },
            currentYear: function () {
                return moment().year();
            },
            console: function (event) {
                console.log(event);
            },
            constructForm: function () {
                return JSON.stringify({
                    "statut": this.newOrder.statut.id,
                    "date": this.newOrder.date,
                    "comment": this.newOrder.comment,
                    "id_club": this.newOrder.id_club,
                })
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            isInputLoading: function (input) {
                return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
            },
            addToLoadingInputs: function (input) {
                this.loadingInputs.push(input)
            },
            removeFromLoadingInputs: function (input) {
                this.loadingInputs = _.without(this.loadingInputs, input)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/MyABFT/ModalNewOrder.vue